module.exports = __webpack_public_path__ + "img/ch5.05e2645d.jpg";